export default "__VITE_ASSET__DsOkyUBJ__"